import { $el, createElem, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Button = /** @class */ (function () {
    function Button() {
        this.VERSION = '1.1.1';
        this.COMPONENTS = $el("." + PREFIX.button, { all: true });
        this._getAllBtns(this.COMPONENTS);
    }
    Button.prototype.config = function (el) {
        var target = typeof el === 'string' ? $el(el) : el;
        validComps(target, 'button');
        return {
            get loading() {
                return this.loading;
            },
            set loading(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                Button.prototype._setLoading(target, false, newVal);
            }
        };
    };
    Button.prototype._getAllBtns = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), icon = _a.icon, loading = _a.loading;
            _this._setIcon(node, icon);
            _this._setLoading(node, true, loading);
            removeAttrs(node, ['icon', 'loading']);
        });
    };
    Button.prototype._setIcon = function (node, icon) {
        if (!icon)
            return;
        if (node.innerHTML === '') {
            node.classList.add(PREFIX.button + "-icon-only");
            var ButtonIcon = "\n              <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-" + icon + "\"></i>\n            ";
            setHtml(node, ButtonIcon);
        }
        else {
            var Icon = createElem('i');
            Icon.className = PREFIX.icon + " " + PREFIX.icon + "-" + icon;
            node.prepend(Icon);
        }
    };
    // 2021.5.23
    // v1.1.0 修复按钮 loading 状态下加载中图标和原有图标并列显示的 bug
    Button.prototype._setLoading = function (node, firstRender, loading) {
        var _a;
        var OriginalIcon = node.querySelector('.rab-icon');
        var LoadingIcon = createElem('i');
        LoadingIcon.className = "rab-load-loop " + PREFIX.icon + " " + PREFIX.icon + "-loading-solid";
        if (loading) {
            if (OriginalIcon)
                setCss(OriginalIcon, 'display', 'none');
            if (node.innerHTML === '')
                node.classList.add(PREFIX.button + "-icon-only");
            node.classList.add(PREFIX.button + "-loading");
            node.prepend(LoadingIcon);
        }
        else {
            if (firstRender)
                return;
            // 2021.6.18
            // v1.1.1 修复在没有图标仅有文本的状态下，切换为loading状态并在状态结束后无法切换为原样 bug
            // setCss(node.children[1], 'display', '');
            if (node.children[1])
                setCss(node.children[1], 'display', '');
            if (node.classList.contains(PREFIX.button + "-loading"))
                node.classList.remove(PREFIX.button + "-loading");
            if (node.classList.contains(PREFIX.button + "-icon-only"))
                node.classList.remove(PREFIX.button + "-icon-only");
            (_a = node.firstElementChild) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    Button.prototype._attrs = function (node) {
        return {
            icon: getStrTypeAttr(node, 'icon', ''),
            loading: getBooleanTypeAttr(node, 'loading')
        };
    };
    return Button;
}());
export default Button;
